<template>
    <div class="home">
        <!-- <div class="menus row-center">
            <div class="menu-left">
                <menu-button @click="menu === 1 ? menu = -1 : menu = 1" :selected="menu === 1" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/park.png'),
                        require('../assets/img/park_c.png'),
                    ]" content="园区概况" v-on:onSelected="sendMessage('parkOverview')"
                    v-on:onUnselected="sendMessage('clearParkOverview')">
                </menu-button>
            </div>
            <div class="menu-right row-center">
                <menu-button @click="menu === 2 ? menu = -1 : menu = 2" :selected="menu === 2" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/site.png'),
                        require('../assets/img/site_c.png'),
                    ]" content="变配站点" v-on:onSelected="sendMessage('siteOverview')"
                    v-on:onUnselected="sendMessage('clearSiteOverview')">
                </menu-button>
                <menu-button @click="menu === 3 ? menu = -1 : menu = 3" :selected="menu === 3" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/safety.png'),
                        require('../assets/img/safety_c.png'),
                    ]" content="安防监控" v-on:onSelected="sendMessage('safetyOverview')" v-on:onUnselected="sendMessage('clearSafetyOverview')">
                </menu-button>
                <menu-button @click="menu === 4 ? menu = -1 : menu = 4" :selected="menu === 4" :bg="[
                        require('../assets/img/button.png'),
                        require('../assets/img/button_c.png'),
                    ]" :icons="[
                        require('../assets/img/electric.png'),
                        require('../assets/img/electric_c.png'),
                    ]" content="电缆走向" v-on:onSelected="sendMessage('electricLine')"
                    v-on:onUnselected="sendMessage('clearElectricLine')">
                </menu-button>
            </div>
        </div> -->

        <div class="menus column-center">
            <MenuButtonColumn @click="menu === 1 ? menu = -1 : menu = 1" :selected="menu === 1" :icons="[
                    require('../assets/img/park.png'),
                    require('../assets/img/park_c.png'),
                ]" content="园区概况" v-on:onSelected="sendMessage('parkOverview')"
                v-on:onUnselected="sendMessage('clearParkOverview')">
            </MenuButtonColumn>
            <MenuButtonColumn @click="menu === 2 ? menu = -1 : menu = 2" :selected="menu === 2" :icons="[
                    require('../assets/img/site.png'),
                    require('../assets/img/site_c.png'),
                ]" content="站点分布" v-on:onSelected="sendMessage('siteOverview')"
                v-on:onUnselected="sendMessage('clearSiteOverview')">
            </MenuButtonColumn>
            <MenuButtonColumn @click="menu === 3 ? menu = -1 : menu = 3" :selected="menu === 3" :icons="[
                    require('../assets/img/power.png'),
                    require('../assets/img/power_c.png'),
                ]" content="用电统计" v-on:onSelected="sendMessage('powerMonitor')"
                v-on:onUnselected="sendMessage('clearPowerMonitor')">
            </MenuButtonColumn>
            <MenuButtonColumn v-if="$store.state.projectId != 4 && $store.state.projectId != 6" @click="menu === 4 ? menu = -1 : menu = 4" :selected="menu === 4" :icons="[
                    require('../assets/img/electric.png'),
                    require('../assets/img/electric_c.png'),
                ]" content="供配线缆" v-on:onSelected="sendMessage('electricLine')"
                v-on:onUnselected="sendMessage('clearElectricLine')">
            </MenuButtonColumn>
        </div>

        <ParkOverView :projectId="$store.state.projectId" />
        <ElectricChart :paramType="'PROJECT_ID'" />
        <ParkOperationData @showAlarmPosition="showAlarmPositionBy" />
        <Surveillance :areaId="-1" :cType="currentType" :cDetails="currentDetails" />
        <Distribution :areaId="-1" />

        <transition name="alarm">
            <div v-if="alarmState && alarmTime === 'show'" class="alarm">
                <div class="alarm-container">
                    <div class="icon"></div>
                    <div class="text">{{this.alarm.text}}</div>
                    <div class="time">{{this.alarm.time}}</div>
                    <div class="position" @click="showAlarmPosition"></div>
                    <div class="close" @click="alarmState = !alarmState"></div>
                </div>
            </div>
        </transition>

        <iframe name="GIS" frameborder="0" width="100%" height="100%" ref="iframeDom" :src=" url + $store.state.gisUrl">
        </iframe>

        <!-- <iframe name="GIS" frameborder="0" width="100%" height="100%" ref="iframeDom" src="http://127.0.0.1:5502/Apps/Sandcastle/gallery/CSKT_web.html">
        </iframe> -->
    </div>
</template>

<script>
    import ParkOverView from "./contentBlock/ParkOverView";
    import ElectricChart from './contentBlock/ElectricChart';
    import ParkOperationData from './contentBlock/ParkOperationData';
    import Surveillance from './contentBlock/Surveillance';
    import Distribution from './contentBlock/Distribution';
    import MenuButton from "../components/MenuButton";
    import MenuButtonColumn from "../components/MenuButtonColumn";
    import {
        config
    } from '../config'
    import {
        GetAlarmList,
    } from "../components/Request";
    import DateDiff from "../components/DateDiff"

    export default {
        name: "OverView",
        components: {
            ParkOverView,
            ElectricChart,
            ParkOperationData,
            Surveillance,
            Distribution,
            MenuButton,
            MenuButtonColumn,
        },
        data() {
            return {
                // 底部导航菜单
                menu: 1,

                // 安防类型
                currentType: 0,
                // 安防设备
                currentDetails: 0,

                alarmId: 0,

                // 顶部报警事件
                alarmState: false,
                alarmTime: 'hidden',
                alarm: {
                    type: '遥测越限事件',
                    area: 'A栋生产车间',
                    text: '动力回路-过压报警',
                    time: '一小时前',
                },

                url: config.gisUrl,
                iframeWin: {},

                timer: null,
            };
        },
        mounted() {
            this.iframeWin = this.$refs.iframeDom.contentWindow;
            window.addEventListener("message", this.handleMessage);
            this.getAlarmInfo()

            this.timer = setInterval(() => this.getAlarmInfo(), 1000 * 60)
        },
        beforeDestroy() {
            window.removeEventListener("message", this.handleMessage)
            this.timer && clearInterval(this.timer)
            this.timer && (this.timer = null)
        },
        watch: {
            alarmTime(n, o) {
                if (n === 'show') {
                    setTimeout(() => {
                        this.alarmTime = 'hidden'
                    }, 1000 * 30)
                }
            }
        },
        methods: {
            getAlarmInfo() {
                GetAlarmList({
                    projectId: this.$store.state.projectId,
                    size: 1,
                    page: 1
                }).then(({
                    data
                }) => {
                    let datas = data.data.alarms
                    if (datas.length > 0) {
                        this.alarmState = true
                        if (datas[0].id != this.alarmId) {
                            this.alarmId = datas[0].id
                            this.alarmTime = 'show'
                        }
                        this.alarm.type = ''
                        this.alarm.area = datas[0].area_name
                        this.alarm.text = (datas[0].loop_name || datas[0].device_name) + '-' + datas[0].alarm_type_desc
                        this.alarm.time = DateDiff((new Date(datas[0].start_time)).getTime())
                    } else {
                        this.alarmState = false
                        this.alarmTime = 'hidden'
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            sendMessage(value) {
                this.iframeWin.postMessage({
                    cmd: value,
                }, "*");
            },
            showAlarmPosition() {
                this.menu = 0
                console.log(this.alarm);
                this.iframeWin.postMessage({
                        cmd: "showAlarmPosition",
                        value: this.alarm
                    },
                    "*"
                );
            },
            showAlarmPositionBy(value) {
                this.menu = 0
                this.iframeWin.postMessage({
                        cmd: "showAlarmPosition",
                        value: value
                    },
                    "*"
                );
            },
            handleMessage(event) {
                const data = event.data;
                // console.log(data)
                switch (data.cmd) {
                    case "returnData":
                        console.log("得到html数据: " + data.params.data);
                        let val = data.params.data
                        if (val.type == "site") {
                            if (val.id == -1) {
                                this.$message({
                                    message: "此站点暂无监控",
                                    center: true,
                                });
                            } else if (val.id != -1) {
                                this.$router.push({
                                    path: "/site/" + val.id
                                });
                            }
                        } else if (val.type == "monitor") {
                            this.currentType = 0;
                            this.currentDetails = val.id;
                        }
                        break;
                        // 会一直触发
                        // case "loadEnd":
                        //     setTimeout(() => {
                        //         this.alarmTime = 'show'
                        //     }, 3000)
                        //     break;
                    case "3Dstart":
                        setTimeout(()=>{
                            if(this.menu == -1){
                                this.menu = 1
                                console.log('显示园区概况');
                            }else{
                                this.menu = -1
                                console.log('显示园区概况');
                                setTimeout(()=>{
                                    this.menu = 1
                                },100)
                            }
                        },3000)
                        break;
                }
            },
        },
    };
</script>

<style lang="less" scoped>
    .home {
        margin: 0;
        padding: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }

    .alarm {
        .w(604);
        .h(70);
        background-image: url(../assets/img/背板.png);
        background-size: 100% 100%;
        position: fixed;
        top: 1440/108vh;
        left: 6590/192vw;
        display: flex;
        justify-content: center;
        align-items: center;

        .alarm-container {
            .w(596);
            .h(31);
            background: rgba(3, 13, 24, 0.5);
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            color: #E6F3FD;

            .icon {
                .w(19);
                .h(18);
                background-image: url(../assets/img/警告.png);
                background-size: 100% 100%;
            }

            .text {
                .w(350);
                .h(31);
                font-size: 16rem;
                line-height: 1.5;
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }

            .time {
                .w(100);
                .h(31);
                font-size: 16rem;
                display: flex;
                justify-content: flex-end;
                align-items: center;
            }

            .position {
                .w(14);
                .h(16);
                background-image: url(../assets/img/position.png);
                background-size: 100% 100%;
                cursor: pointer;
            }

            .close {
                .w(14);
                .h(14);
                background-image: url(../assets/img/关闭.png);
                background-size: 100% 100%;
                cursor: pointer;
            }
        }
    }

    .menus {
        .w(160);
        position: fixed;
        .wh(449, 54);
        left: @w;
        bottom: @h;
        justify-content: space-between;
        background: url(../assets/img/menu_bg.png);
        background-size: 100% 100%;
        opacity: 0.75;
    }

    .parkOverview {
        width: 1600/192vw;
        height: 480/108vh;
        position: fixed;
        bottom: 500/108vh;
        left: 4490/192vw;
        background-size: 100% 100%;
    }

    .parkOverview_c {
        width: 1600/192vw;
        height: 480/108vh;
        position: fixed;
        bottom: 500/108vh;
        left: 4490/192vw;
        background-size: 100% 100%;
    }

    .alarm-enter,
    .alarm-leave-to {
        top: 0,
    }

    .alarm-enter-active,
    .alarm-leave-active {
        transition: top 1s
    }
</style>